<template>
  <div class="join-us-background">
    <div class="join-us-banner">
      <div class="join-us-container">
        <div class="join-us-banner-title">{{ $t("join.banner") }}</div>
      </div>

      <img class="join-us-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="join-us-container">
      <div class="join-us-content">
        <div class="join-us-content-info">
          <div
            class="product-markdown-content"
            v-html="markdownHtml"
          ></div>
          <img
            class="join-us-hr-wechat"
            src="../../assets/about/hr_wechat.png"
            alt="HR WeChat"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import joinUsMd from '!!../../../loaders/md-loader.js!@/common/lang/zh/JoinUS.md'
import joinUsMdEn from '!!../../../loaders/md-loader.js!@/common/lang/en/JoinUS.md'
import { parseMarkdown } from '@/utils/simpleMarkdown'

export default {
  name: 'JoinUs',
  computed: {
    markdownHtml() {
      const md = this.$i18n.locale === 'en' ? joinUsMdEn : joinUsMd
      return parseMarkdown(md)
    }
  }
}
</script>

<style scoped>
.join-us-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.join-us-background {
  margin-top: 70px;
}
.join-us-banner {
  overflow: hidden;
}
.join-us-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.join-us-banner-img {
  min-width: 100%;
  height: 165px;
}
.join-us-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.join-us-content-info {
  margin-top: 40px;
}
.join-us-hr-wechat {
  display: block;
  max-width: 280px;
  width: 100%;
  height: auto;
  margin: 40px 0 0;
}
.product-markdown-content {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.product-markdown-content >>> h2 {
  margin-top: 40px;
  margin-bottom: 12px;
  font-size: 22px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
}
.product-markdown-content >>> h3 {
  margin-top: 50px;
  margin-bottom: 16px;
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
  text-align: center;
}
.product-markdown-content >>> h4 {
  margin-top: 16px;
  margin-bottom: 8px;
  font-size: 18px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(79, 76, 77, 1);
  line-height: 50px;
}
.product-markdown-content >>> p {
  margin-bottom: 12px;
}
.product-markdown-content >>> strong {
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(79, 76, 77, 1);
}
.product-markdown-content >>> a {
  color: rgba(73, 145, 201, 1);
  text-decoration: none;
  cursor: pointer;
}
.product-markdown-content >>> a:hover {
  text-decoration: underline;
}
.product-markdown-content >>> ol {
  padding-left: 20px;
  margin-bottom: 16px;
}
.product-markdown-content >>> ol.md-paren-list {
  list-style-type: none;
  padding-left: 0;
  counter-reset: paren-item;
}
.product-markdown-content >>> ol.md-paren-list > li {
  counter-increment: paren-item;
}
.product-markdown-content >>> ol.md-paren-list > li::before {
  content: "（" counter(paren-item) "）";
  margin-right: 4px;
}
.product-markdown-content >>> li {
  margin-bottom: 8px;
}
@media screen and (max-width: 482px) {
  .join-us-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .join-us-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .join-us-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .join-us-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .join-us-container {
    max-width: 1068px;
  }
}
</style>
